"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPersonaIds = exports.getCommunityImages = exports.getCommunitiesSortedAlphabetically = exports.communities = void 0;

var actions = _interopRequireWildcard(require("../actions/campaignCreator"));

var _reselect = require("reselect");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var intialState = {
  isFetching: false,
  bySlug: {},
  order: []
}; // $FlowFixMe

var communities = function communities(state, action) {
  if (state === void 0) {
    state = intialState;
  }

  switch (action.type) {
    case actions.LOAD_COMMUNITIES_AND_PERSONAS_REQUEST:
      return _extends({}, state, {
        isFetching: true,
        accessInfo: {}
      });

    case actions.LOAD_COMMUNITIES_AND_PERSONAS_FAILURE:
      return _extends({}, state, {
        isFetching: false,
        accessInfo: action.accessInfo && action.accessInfo.content
      });

    case actions.LOAD_COMMUNITIES_AND_PERSONAS_SUCCESS:
      return _extends({}, state, action.payload, {
        isFetching: false,
        accessInfo: action.accessInfo && action.accessInfo.content
      });

    default:
      return state;
  }
};

exports.communities = communities;
var getCommunitiesSortedAlphabetically = (0, _reselect.createSelector)(function (state) {
  return state.communities.bySlug;
}, function (items) {
  return items && Object.keys(items).sort(function (a, b) {
    // return items[ a ].name - items[ b ].name;
    if (items[a].postTitle === undefined || items[b].postTitle === undefined) {
      return 0;
    }

    if (items[a].postTitle.toLowerCase() < items[b].postTitle.toLowerCase()) {
      return -1;
    } else if (items[a].postTitle.toLowerCase() > items[b].postTitle.toLowerCase()) {
      return 1;
    } else {
      return 0;
    }
  }).map(function (sortedKey) {
    return items[sortedKey];
  });
});
exports.getCommunitiesSortedAlphabetically = getCommunitiesSortedAlphabetically;
var getCommunityImages = (0, _reselect.createSelector)(function (state) {
  return getCommunitiesSortedAlphabetically(state);
}, function (items) {
  return items.map(function (item) {
    return item.acf.featuredImage.sizes.medium;
  });
});
exports.getCommunityImages = getCommunityImages;
var getPersonaIds = (0, _reselect.createSelector)(function (state) {
  return getCommunitiesSortedAlphabetically(state);
}, function (items) {
  return items.reduce(function (personaIds, community) {
    var communityPersonaIds = community.personas.map(function (persona) {
      return persona.postName;
    });
    return [].concat(personaIds, communityPersonaIds);
  }, []);
});
exports.getPersonaIds = getPersonaIds;